import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../component/MotionWrapper';
import Main_Winter from '../component/Winter/Main_Winter';
import Save_Date_Fall from '../component/Fall/Save_Date_Fall';
import axios from 'axios';
import Info_Fall from '../component/Fall/Info_Fall';
import Letter from '../component/Spring/Letter';
import Dday_Spring from '../component/Spring/Dday_Spring';
import Message_Spring from '../component/Spring/Message_Spring';
import Location_Spring from '../component/Spring/Location_Spring';
import Footer from '../component/Footer';
import Loading from '../component/Loading';
import Location_Desc from '../component/Location/Location_Desc';
import Music from '../component/Music';
import Sharing from '../component/Sharing';
import GalleryList from '../component/Gallery/GalleryList';
import CallInfo from '../component/CallInfo';
import Interview_Spring from '../component/Spring/Interview_Spring';
import AccountList2 from '../component/Account/AccountList2';
import AccountList from '../component/Account/AccountList';
import Information from '../component/Information';
import Main_Spring from '../component/Spring/Main_Spring';
import Save_Date from '../component/Save_Date';
import Info_Spring from '../component/Spring/Info_Spring';


const SongEunJin = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);
    
    const openTitle = "이재훈 ♥ 송은진 결혼식에 초대합니다";
    const openDesc = " 5/11(일) 오전 11시 안산AW컨벤션";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/90/thumb.JPG";

    const lng = 126.828818362901;
    const lat = 37.308201295112;

    const placeTelNum = "031-501-5900";

    const forSubway = "지하철 4호선 고잔역 2번출구 - 셔틀버스 운행";
    const forBus = "∙ 안산 문화숲의 광장 하차 88\n∙ 동남레이크빌 하차 99-1, 3100\n∙ 대림호수공원아파트 하차 77,98";
    const forParking = "* 주차요원 안내를 꼭 받아주세요\n∙ 양지주차타워(AW 주차타워)\n∙ MK 주차타워\n∙ 공영주차장(정문 맞은 편)";


    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });

    const conceptStyle = {
        // spring 핑크B
        concept: "SPRING",
        titleColor: "#ff8faf",
        pointColor: "#ff8faf",
        btnBgColor: "#ffcfe1",
        fontColor: "#313131",
        btnFontColor: "#313131",
        chatBgColor: "#fff5f9",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }
    
    
    
    const msg1 = "함께해온 지난 시간만큼\n서로의 세상을 짊어지고\n새벽을 향해 걸어가기 위해\n앞으로 더 많은 시간을 함께 보내고자 합니다";
    const msg2 = "수많은 시간을 함께하기 위한 그 시작의 길에\n소중한 여러분들을 초대합니다.";


    const groomAccountList = [
        {
            role: "신랑",
            name: "이재훈",
            bank: "농협은행",
            accountNumber : "352-1102-0729-03",
            isKakao : false
        },
        {
            role: "신랑 부",
            name: "이상익",
            bank: "국민은행",
            accountNumber : "673001-01-562849",
            isKakao : false
        }
        // ,{
        //     role: "신랑 모",
        //     name: "홍필선",
        //     bank: "카카오뱅크",
        //     accountNumber : "3333-32-5656811",
        //     isKakao :false
        // }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "송은진",
            bank: "카카오뱅크",
            accountNumber : "3333-17-8124215",
            isKakao : false
        }
        // ,{
        //     role: "신부 부",
        //     name: "신현호",
        //     bank: "농협은행",
        //     accountNumber : "616-12-137427",
        //     isKakao : false
        // }
        ,{
            role: "신부 모",
            name: "박경희",
            bank: "우리은행",
            accountNumber : "1002-946-44-9708",
            isKakao : false
        }
    ]

    const account_explain = "먼 곳에서 마음 전하고 싶으신 분들을 위해 \n계좌번호를 기재하였습니다";

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "변종욱",
            call: "010-6636-5638"
        },
        {
            role: "신랑 부",
            name: "변민석",
            call: "010-3862-5638"
        },
        {
            role: "신랑 모",
            name: "김은하",
            call: "010-7331-5638"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "배민지",
            call: "010-5430-9890"
        },
        {
            role: "신부 부",
            name: "배종진",
            call: "010-5430-0303"
        },
        {
            role: "신부 모",
            name: "정성례",
            call: "010-3882-3777"
        }
    ]

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "후련할 거 같아!",
            brideAnswer: "신혼여행❤"
        },
        {
            question : "우리의 결혼에서 가장 중요한 가치는?",
            groomAnswer: "peace",
            brideAnswer: "fidelity"
        },
        {
            question : "우리의 인생의 목표는?",
            groomAnswer: "건강하게 오래 살기",
            brideAnswer: "순간을 즐기며 행복하게"
        },
        {
            question : "10년, 20년 후 우리의 모습은 어떤 모습일까?",
            groomAnswer: "변치 않을거야.",
            brideAnswer: "어른이 될거야."
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "사랑해 영원히.",
            brideAnswer: "덕분에 행복해."
        }
    ]


    const informationList =[
        {
            title : "피로연 안내",
            content : "25년 3월 1일 \n 서귀포시 대정읍 하모리 동성수산"
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  // Call once on mount
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    const toUpperCaseString = (str) => {
        const nameParts = str.split(' '); 
        return nameParts.slice(1).join(' ').toUpperCase();
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstEnName = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };


    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#ff8faf"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept}/>
                    <Main_Spring groomNameEn={toUpperCaseString(weddingData.groomNameEn)} brideNameEn={toUpperCaseString(weddingData.brideNameEn)} weddingData={weddingData} color={conceptStyle.pointColor}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={false} marginTop={"100px"} marginBottom={"0px"} fontSize={"16px"}/>
                    <Info_Spring weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>     
                    <Letter titleFontSize={"18px"} fontSize={"13px"} title={"재훈 ♥ 은진 결혼식에 초대합니다"} msg1={msg1} msg2={msg2} conceptStyle={conceptStyle}/>
                    {/* <CallInfo conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring isAttendFromClose={true} groomName={getFirstKoName(weddingData.groomName)} brideName={getFirstKoName(weddingData.brideName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                    <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={9} photoWidth={"110px"} photoHeight={"150px"} gap={"3px"}/>
                        <MotionWrapper initialY={70}>
                        <AccountList2 titleFontSize={"15px"} fontSize={"14px"} conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                            <MotionWrapper initialY={70}>
                                <Message_Spring titleFontSize={"18px"} fontSize={"14px"} weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                                    conceptStyle={conceptStyle} 
                                    btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                                    />
                                <MotionWrapper initialY={50}>
                                    {/* <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} /> */}
                                    <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                                    <Location_Desc titleFontSize={"16px"} fontSize={"13px"} isPoint={true} forBus={forBus} forSubway={forSubway} forParking={forParking} conceptStyle={conceptStyle}/>
                                    {/* <Information pointFontColor={"#9b111e"} conceptStyle={conceptStyle} informationList={informationList} /> */}
                                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                                    <Footer />
                                </MotionWrapper>
                            </MotionWrapper>
                        </MotionWrapper>
                    </MotionWrapper>
                </>
            )}
        </div>
    );
    
};

export default SongEunJin;